import jquery from 'jquery'

export const serverUrl = () => {
    return (process.env.NODE_ENV === 'production' ?  '/api' : 'http://localhost:3000/api')
}

export const customRequest = (action, data) => {

    const params = ( action.method === 'GET' ? '?'+jquery.param(data) : '')
    
    let  actionURL = action.url
    if(data)
	actionURL = actionURL.replace(':id', data.id)
    return fetch(serverUrl()+actionURL+params, { method: action.method,
						 headers: getHeaders(),
						 credentials: 'include',
						 body: (action.method !== 'GET' ? JSON.stringify(data) : null) })
	.then(handleErrors)
	.then(getJson)
};


export const stringToNumber = (str) => {
    
    if(str)
	return parseFloat(String(str).replace(".", "").replace(",", "."))
}


function getHeaders(){
    
    return {
	'Accept': 'application/json', 
	'Content-Type': 'application/json'
    }
}


function handleErrors(response) {
 
  //  if(response.status === 401)
//	throw Error(401)
    if (!response.ok) {
        throw response.status;
    }
    else
	return response;
}



function getJson(response) {
 
    if(response)
	return response.json();
}



// WEBPACK FOOTER //
// ./src/utils/restUtils.js